export default __webpack_public_path__ + "static/media/category_lSleeve.e789900c.webp";